class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.predictiveSearchForm = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('.predictive-search-results');
        this.searchDropdownContainer = this.querySelector('.search-dropdown-container');
        this.recommendationProducts = this.querySelector('.search-dropdown-recommendations');
        this.searchLabel = this.querySelector('.search-dropdown-form__search-label');

        PredictiveSearch.instanceCount = (PredictiveSearch.instanceCount || 0) + 1;
        const instanceId = PredictiveSearch.instanceCount;
        const inputId = `predictive-search-input-${instanceId}`;
        const resultsId = `predictive-search-results-${instanceId}`;

        this.id = `predictive-search-${instanceId}`;
        this.input.id = inputId;
        this.predictiveSearchResults.id = resultsId;
        this.input.setAttribute('role', 'combobox');
        this.input.setAttribute('aria-expanded', 'false');
        this.input.setAttribute('aria-haspopup', 'listbox');
        this.input.setAttribute('aria-controls', resultsId);
        this.input.setAttribute('aria-owns', resultsId);
        this.input.setAttribute('aria-autocomplete', 'list');

        if (this.searchLabel) {
            this.searchLabel.setAttribute('for', inputId);
        }

        this.input.addEventListener('focus', () => {
            const dropdown = this.closest('search-dropdown');
            if (dropdown) {
                dropdown.classList.add('active');
            }
        });

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        const searchTerms = new URLSearchParams(new FormData(this.predictiveSearchForm));
        this.getSearchResults(searchTerms.toString());
    }

    getSearchResults(searchTerms) {
        fetch(`${window.Shopify.routes.root}search/suggest?${searchTerms}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    const error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((responseText) => {
                const responseSection = new DOMParser()
                    .parseFromString(responseText, 'text/html')
                    .querySelector('#shopify-section-predictive-search');

                if (!responseSection) {
                    this.close();
                    return;
                }

                this.predictiveSearchResults.innerHTML = responseSection.innerHTML;

                const resultsLazyloadImages = this.predictiveSearchResults.querySelectorAll('.lazy-loading-image');

                resultsLazyloadImages.forEach((imageContainer) => {
                    lazyloading(imageContainer);
                });

                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.searchDropdownContainer.classList.add('has-predictive-search-results');
        this.input.setAttribute('aria-expanded', 'true');

        if (this.recommendationProducts) {
            this.recommendationProducts.classList.add('inactive');
        }
    }

    close() {
        this.searchDropdownContainer.classList.remove('has-predictive-search-results');
        this.input.setAttribute('aria-expanded', 'false');

        if (this.recommendationProducts) {
            this.recommendationProducts.classList.remove('inactive');
        }
    }

    debounce(fn, wait) {
        let timeout;

        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
